import { HttpClient } from '@angular/common/http';
import { Language } from '@auth/login/data/login.model';
import { TranslateLoader } from '@ngx-translate/core';
import { catchError, Observable } from 'rxjs';
import { environment } from 'environments/environment';

export function createTranslateLoader(http: HttpClient) {
  return new CustomTranslationLoader(http);
}

export class CustomTranslationLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    // Replace '-' with '_' in the language code if present because of lokalise format
    lang = lang.includes('-') ? lang.replace('-', '_') : lang;

    if (lang === 'en') {
      lang = 'en_GB';
    }

    // Special case for translationKeys
    if (lang === Language.TRANSLATION_KEYS) {
      return this.http.get<{ [key: string]: string }>('/assets/i18n/translationKeys.json');
    }

    const baseUrl = `${environment.translationCacheServiceUrl}`;

    // In local development, use the assets folder for translations
    const url = environment.localhost
      ? `/assets/i18n/${lang}.json`
      : `${baseUrl}/translations/download?projectId=${environment.lokaliseProjectId}&language=${lang}`;

    return this.http.get<{ [key: string]: string }>(url).pipe(
      catchError(() => {
        return this.http.get<{ [key: string]: string }>('/assets/i18n/en_GB.json');
      })
    );
  }
}
